import React, {useEffect, useState} from "react";
import dayjs from "dayjs";
import {ORDERS_HISTORY_PATH} from "../../../routes";
import {Box, FormControl, IconButton, InputLabel, MenuItem, Modal, OutlinedInput, Select, Typography} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";


export function ModalDeliveryPointAndPurchaseOrderNumber({ open, puntosEntrega, handleSetDelivery, feature, navigator, }) {
    const [selectedPuntoEntrega, setSelectedPuntoEntrega] = useState('');
    const [selectedDeliveryDate, setSelectedDeliveryDate] = useState('');
    const [purchaseOrderNumber, setPurchaseOrderNumber] = useState('');
    const [orderExists, setOrderExists] = useState(false);
    const [creatingOrder, setCreatingOrder] = useState(false);
    dayjs.locale('es');

    const handlePuntoEntregaChange = (event) => {
        const deliverySiteName = event.target.value;
        setSelectedPuntoEntrega(deliverySiteName);
        setSelectedDeliveryDate('')
        setPurchaseOrderNumber('')
        feature.updateDeliveryDatesFor(deliverySiteName, purchaseOrderNumber)
    };

    const handleDeliveryDateChange = async (value) => {
        if (isValidDateFormat(value)) {
            setSelectedDeliveryDate(value);
            await feature.existsSameOrderWith(value, selectedPuntoEntrega, purchaseOrderNumber)
            setOrderExists(feature.existsAnOrderForSelectedDate());
            if (feature.existsAnOrderForSelectedDate()) {
                setConfirmRedirectOpen(true);

            }
        }
    };

    const isValidDateFormat = (date) => {
        return (date !== null && date.isValid?.() && (date.year() >= 1000))
    }

    const handlePurchaseOrderNumberChange = async (event) => {
        const value = event.target.value;
        if (/^\d*$/.test(value)) {
            setPurchaseOrderNumber(value);
            if (selectedDeliveryDate !== '') {
                await feature.existsSameOrderWith(selectedDeliveryDate, selectedPuntoEntrega, value)
                const exists = feature.existsAnOrderForSelectedDate();
                setOrderExists(exists);
                if (feature.existsAnOrderForSelectedDate()) {
                    setConfirmRedirectOpen(true);
                }
            }
        }
    }

    const handleConfirm = async () => {
        setCreatingOrder(true)
        await handleSetDelivery(selectedPuntoEntrega, selectedDeliveryDate, purchaseOrderNumber);
        feature._isDeliveryPointModalOpened = false;
    };

    const handleClose = () => {
        if (feature.wasDeliverySiteAndDeliveryDateChosen()) {
            feature._isDeliveryPointModalOpened = false;
            setSelectedDeliveryDate('');
        }
    }

    const [confirmRedirectOpen, setConfirmRedirectOpen] = useState(false);

    const handleConfirmRedirect = () => {
        setConfirmRedirectOpen(false);
        navigator(ORDERS_HISTORY_PATH);
    };

    const handleCancelRedirect = () => {
        setConfirmRedirectOpen(false);
    };

    useEffect(() => {
        if (!open) return;

        const deliverySiteName = feature.getDeliverySiteName();
        const orderNumber = feature.purchaseOrderNumber();

        setSelectedPuntoEntrega(deliverySiteName || '');
        setPurchaseOrderNumber(orderNumber || '');

        if (deliverySiteName) {
            feature.updateDeliveryDatesFor(deliverySiteName, orderNumber);

            const rawDate = feature.getDeliveryDate();
            const parsedDate = rawDate ? dayjs(rawDate, 'DD-MM-YYYY') : null;

            setSelectedDeliveryDate(parsedDate?.isValid() ? parsedDate : null);
        } else {
            setSelectedDeliveryDate(null);
        }
    }, [open]);

    const cannotConfirm = creatingOrder || selectedPuntoEntrega === "" || selectedDeliveryDate === "" ||
        orderExists || !feature.isDateValidForDelivery(selectedDeliveryDate);

    const ConfirmRedirectModal = ({open, onConfirm, onCancel}) => (
        <Modal open={open} onClose={onCancel}>
            <Box sx={{
                ...style,
                width: 450,
                p: 4,
                textAlign: 'center',
                borderRadius: '8px',
                backgroundColor: '#f9f5ee',
                "@media (max-width: 768px)": {
                    width: "95%",
                },
            }}>
                <IconButton onClick={onCancel} sx={{position: 'absolute', top: 5, right: 5}}>
                    <CloseIcon/>
                </IconButton>
                <Typography
                    variant="h5"
                    gutterBottom
                    sx={{fontFamily: 'ArcherSmbd', fontWeight: 'bold', fontSize: '16px'}}
                >
                    Ya existe un pedido para esta fecha.
                </Typography>
                <Typography
                    variant="body1"
                    gutterBottom
                    sx={{fontFamily: 'ArcherSmbd', fontSize: '18px'}}
                >
                    ¿Desea ir al historial de pedidos?
                </Typography>

                <Box sx={{mt: 2, display: 'flex', justifyContent: 'space-around'}}>
                    <button
                        className="btn btn-primary btn-add-to-cart"
                        style={{
                            color: '#ffffff',
                            backgroundColor: '#c1a17d',
                            borderColor: '#c1a17d',
                            fontWeight: 'bold',
                            fontSize: '12px',
                            padding: '8px 10px'
                        }}
                        onClick={onConfirm}
                    >
                        Si, ir al historial
                    </button>

                    <button
                        className="btn btn-primary btn-add-to-cart"
                        style={{
                            color: '#ffffff',
                            backgroundColor: '#c1a17d',
                            borderColor: '#c1a17d',
                            fontWeight: 'bold',
                            fontSize: '12px',
                            padding: '4px 10px',
                        }}
                        onClick={onCancel}
                    >
                        No, cancelar
                    </button>
                </Box>

            </Box>
        </Modal>

    );

    return (
        <>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-delivery-point-title"
                aria-describedby="modal-delivery-point-description"
            >
                <Box className="modal-dialog modal-lg"
                     sx={{outline: 0, maxWidth: '800px', margin: 'auto', mt: {xs: 2, sm: 5},
                          maxHeight: {xs: 'calc(100vh - 32px)', sm: 'calc(100vh - 80px)'}, overflowY: 'auto'}}>
                    <Box className="modal-content"
                         sx={{p: 2, bgcolor: 'background.paper', borderRadius: '8px', boxShadow: 24}}>
                        <Box className="modal-header" sx={{display: 'flex', justifyContent: 'flex-end'}}>
                            {/*<IconButton onClick={handleClose} aria-label="Close">*/}
                            {/*    <Typography variant="subtitle1">Cerrar</Typography>*/}
                            {/*    <CloseIcon fontSize="large" sx={{ ml: 1 }} />*/}
                            {/*</IconButton>*/}
                        </Box>
                        <Box className="modal-body" sx={{p: 2}}>
                            <Typography variant="h4" component="h4" textAlign="center" gutterBottom>
                                <div style={{fontFamily: 'ArcherSmbd, sans-serif', fontWeight: 'bold'}}> Elija el punto
                                    de entrega con el que desea operar
                                </div>
                            </Typography>
                            <FormControl fullWidth variant="outlined" sx={{mt: 2}}>
                                <InputLabel id="punto-entrega-label" style={{fontSize: '0.9em'}}>Punto de
                                    Entrega</InputLabel>
                                <Select
                                    labelId="punto-entrega-label"
                                    id="punto-entrega-select"
                                    value={selectedPuntoEntrega}
                                    onChange={handlePuntoEntregaChange}
                                    label="Punto de Entrega"
                                    variant="outlined"
                                    renderValue={(selected) => {
                                        const selectedItem = puntosEntrega.find(item => item.deliverySiteName === selected);
                                        if (!selectedItem) return '';

                                        return (
                                            <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                                                <span
                                                    className="material-symbols-sharp"
                                                    style={{
                                                        fontVariationSettings: "'FILL' 0, 'wght' 150, 'GRAD' 50, 'opsz' 20",
                                                        color: '#000000',
                                                        fontSize: "1.2em",
                                                    }}
                                                >
                                                location_on
                                            </span>
                                                <div style={{
                                                    fontFamily: 'ArcherSmbd',
                                                    fontSize: '16px',
                                                    color: '#000000'
                                                }}>
                                                    {selectedItem.deliverySiteName} - {selectedItem.deliverySiteAddress} - {selectedItem.deliverySiteCity}
                                                </div>
                                            </div>
                                        );
                                    }}
                                    sx={{
                                        backgroundColor: '#ffffff',
                                        borderRadius: '8px',
                                        fontSize: '16px',
                                        color: '#000000',
                                        '& .MuiSvgIcon-root': {
                                            color: '#000000',
                                        },
                                        '&:hover': {
                                            backgroundColor: '#ffffff',
                                        },
                                    }}
                                >
                                    {puntosEntrega.map((item) => (
                                        <MenuItem
                                            key={item.deliverySiteName}
                                            value={item.deliverySiteName}
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '10px',
                                                fontSize: '16px',
                                                color: '#000000',
                                                backgroundColor: '#ffffff',
                                                '&:hover': {
                                                    backgroundColor: '#ffffff',
                                                },
                                            }}
                                        >
                                        <span
                                            className="material-symbols-sharp"
                                            style={{
                                                fontVariationSettings: "'FILL' 0, 'wght' 150, 'GRAD' 50, 'opsz' 20",
                                                color: '#000000',
                                                fontSize: "1.2em",
                                            }}
                                        >
                                            location_on
                                        </span>
                                            <div style={{fontFamily: 'ArcherSmbd'}}>
                                                {item.deliverySiteName} - {item.deliverySiteAddress} - {item.deliverySiteCity}
                                            </div>
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl fullWidth variant="outlined" sx={{mt: 3}}>
                                <InputLabel htmlFor="numero-orden" style={{fontSize: '0.9em'}}>
                                    Número de orden
                                </InputLabel>
                                <OutlinedInput
                                    id="numero-orden"
                                    label="Número de orden"
                                    type="number"
                                    value={purchaseOrderNumber}
                                    disabled={!selectedPuntoEntrega}
                                    onChange={handlePurchaseOrderNumberChange}
                                    sx={{
                                        backgroundColor: '#ffffff',
                                        borderRadius: '8px',
                                        fontSize: '16px',
                                        color: '#000000',
                                        fontFamily: 'ArcherSmbd, sans-serif',
                                        '& input[type=number]': {
                                            MozAppearance: 'textfield',
                                            '& input[type=number]': {
                                                MozAppearance: 'textfield',
                                            },
                                        },
                                    }}
                                />
                            </FormControl>
                            <FormControl fullWidth variant="outlined" sx={{mt: 3}}>
                                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={dayjs.locale()}>
                                    <DatePicker
                                        fullWidth
                                        InputLabelProps={{shrink: false}}
                                        sx={{
                                            backgroundColor: '#ffffff',
                                            borderRadius: '0.5rem',
                                            width: '100%',
                                            '& .MuiInputLabel-root, & .MuiInputLabel-shrink, & .MuiOutlinedInput-root': {
                                                fontSize: '1em',
                                            }
                                        }}
                                        value={selectedDeliveryDate}
                                        format={'DD-MM-YYYY'}
                                        label={'Fecha de entrega'}
                                        onChange={handleDeliveryDateChange}
                                        disabled={!selectedPuntoEntrega}
                                        shouldDisableDate={(date) => !feature.isDateValidForDelivery(date)}
                                        /* closeOnSelect: en celulares MUI abre el calendario como
                                           dialogo y por defecto espera un Aceptar; elegir el dia ya es
                                           decision suficiente, asi que lo cerramos ahi mismo.
                                           El alto acotado mantiene la barra de acciones a la vista: sin
                                           el, la unica salida es tocar afuera, lo que ademas cierra el
                                           modal de entrega y descarta la fecha. */
                                        closeOnSelect
                                        slotProps={{
                                            actionBar: {actions: ['cancel', 'accept']},
                                            dialog: {
                                                sx: {
                                                    '& .MuiPaper-root': {
                                                        maxHeight: 'calc(100vh - 32px)',
                                                        margin: 2,
                                                    },
                                                },
                                            },
                                        }}
                                    />
                                </LocalizationProvider>
                            </FormControl>
                            <Box sx={{display: 'flex', justifyContent: 'center', mt: 4}}>
                                <button
                                    className="btn btn-primary btn-add-to-cart"
                                    style={{
                                        color: '#ffffff',
                                        backgroundColor: '#c1a17d',
                                        borderColor: '#c1a17d',
                                        fontWeight: 'bold',
                                        padding: '8px 20px',
                                        opacity: cannotConfirm ? 0.65 : 1,
                                        transition: 'none',
                                    }}
                                    onClick={handleConfirm}
                                    disabled={cannotConfirm}
                                >
                                    Elegir
                                </button>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Modal>
            <ConfirmRedirectModal
                open={confirmRedirectOpen}
                onConfirm={handleConfirmRedirect}
                onCancel={handleCancelRedirect}
                navigator={navigator}
            />
        </>
    );
}

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
